
import { defineComponent, ref, onActivated, computed, getCurrentInstance, onMounted, SetupContext } from 'vue';
import Skeleton from 'vant/lib/skeleton';
import FoldableItem from '../foldable-item-new/index.vue'
import CommentDialog from '@/components/comment-dialog/seo-index.vue';
import { roundingNum } from '@/common/utils';
import { useCommentDialog } from '@/components/comment-dialog/hooks/useCommentDialog'
import NewOpenKwaiNotice from '@/components/new-open-kwai-notice/index.vue'
import { sendLog, LogType } from '~/common/radar';

const PictureIdPrefix = 'picture-category-card';

export default defineComponent({
  components: {
    FoldableItem,
    CommentDialog,
    NewOpenKwaiNotice,
    Skeleton,
  },
  props: {
    type: {
      type: String,
      default: () => ''
    },
    data: {
      type: Object,
      default: () => { }
    },
    isLoginStatus: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    firstCardFinishLoad: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, ctx: SetupContext<Array<'onFirstFinishRender'>>) {
    const { proxy } = getCurrentInstance() as { proxy: any }

    const isLiked = ref(false)

    const cardType = ref('image-category-card')

    const showNewOpenKwaiNotice = ref(false)

    const imageRef = ref()

    const cardCommonParams = computed(() => {
      return {
        card_type: 'photo_text',
        card_position: props.index,
      }
    })

    const {
      commentLists,
      commentDialogVisable,
      showCommentLoading,
      fetchSeoComment,
    } = useCommentDialog()

    const likeCount = computed(() => {
      return props.data?.feeds?.like_count > 10 ? props.data?.feeds?.like_count : proxy.$root.$t('k_344306')
    })

    const commentCount = computed(() => {
      return proxy.$root.$t('k_467898')
    })

    const shareCount = computed(() => {
      return props.data?.feeds?.forward_count > 10 ? props.data?.feeds?.forward_count : proxy.$root.$t('k_467899')
    })

    const userName = computed(() => {
      return props.data?.feeds?.user_name || ''
    })

    const userHeadIcon = computed(() => {
      return props.data?.feeds?.headurls?.[0]?.url || ''
    })

    const caption = computed(() => {
      return props.data?.feeds?.caption
    })

    const commentLikeCount = computed(() => {
      return roundingNum(props.data?.comment?.commentLikeCount)
    })

    const pictureUrl = computed(() => {
      return props.data?.feeds?.pic_origin_url || ''
    })

    const photoId = computed(() => {
      return props.data?.feeds?.photo_id_str
    })

    // 点赞，记录埋点 + 弹起拉端弹窗
    const handleLikeAction = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'like',
          ...cardCommonParams.value
        }
      })
      showNewOpenKwaiNotice.value = true
    }

    // 点击评论，记录埋点 + 弹起拉端弹窗
    const handleCommentClick = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'comment',
          ...cardCommonParams.value
        }
      })
      showNewOpenKwaiNotice.value = true
      // commentDialogVisable.value = true
      // fetchSeoComment(photoId.value)
    }

    // 点击头像，记录埋点 + 弹起拉端弹窗
    const clickHeaderOrName = () => {
      // ikwai://search?tab=video?source=PWA&keyword=${encodeURIComponent(searchContent.value)}&target_url=${getTargetUrlFromWebOrDesktop()}
      // evokeByTagA(`ikwai://profile/${photoId.value}`)
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'author_icon',
          ...cardCommonParams.value
        }
      })
      showNewOpenKwaiNotice.value = true
    }

    // 点击图片大卡本身，不发生跳转，只进行埋点上报
    const clickPictureCard = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'photo_text',
          ...cardCommonParams.value
        }
      })
    }

    const copyUrl = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'share',
          ...cardCommonParams.value
        }
      })
      proxy.$bus.emit('copyToClipboard', `${window.location.href}?copyType=category`)
    }

    const sendPopShowLog = (logParams: { logType: keyof typeof LogType, params?: Record<string, string> }) => {
      const { logType, params } = logParams
      const valueParams: any = {
        ...params
      }

      sendLog({
        type: logType,
        name: 'PWA_POP',
        value: {
          ...valueParams
        }
      })
    }

    const handleNewOpenKwaiNotice = (params: Record<string, string>) => {
      proxy.$bus.emit('launchApp');
      sendPopShowLog({
        logType: 'click',
        params: {
          button_type: 'download'
        }
      })
      setTimeout(() => {
        showNewOpenKwaiNotice.value = false
      }, 0)
    }

    const handleNewOpenKwaiNoticeClose = () => {
      showNewOpenKwaiNotice.value = false
      sendPopShowLog({
        logType: 'click',
        params: {
          button_type: 'wait'
        }
      })
    }

    const pictureHeight = computed(() => {
      const width = (props?.data?.feeds?.origin_width ?? 0) <= 0 ? 248 : props?.data?.feeds?.origin_width;
      const height = (props?.data?.feeds?.origin_height ?? 0) <= 0 ? 248 : props?.data?.feeds?.origin_height;
      let pictureRealWidth = (imageRef?.value?.clientWidth ?? 0) <= 0 ? 228 : imageRef?.value?.clientWidth ?? 228;
      const scaledHeight = Number(height / width * pictureRealWidth);
      return scaledHeight > 2000 ? 2000 : scaledHeight;
    });

    onMounted(() => {
      if (props?.index === 0) {
        const imgDom = document.getElementById(`${PictureIdPrefix}${props?.index}`) as HTMLImageElement;
        
        const handlePosterImageLoadEnd = () => {
          ctx.emit('onFirstFinishRender', props?.index);
        }

        if (imgDom?.complete || !imgDom) {
          handlePosterImageLoadEnd();
          return;
        }

        imgDom.onload = function() {
          handlePosterImageLoadEnd();
        }

        imgDom.onerror = function() {
          handlePosterImageLoadEnd();
        }
      }
    })

    onActivated(() => {
      commentDialogVisable.value = false
    })

    return {
      likeCount,
      commentCount,
      shareCount,
      commentLikeCount,
      isLiked,
      pictureUrl,
      photoId,
      commentLists,
      commentDialogVisable,
      showCommentLoading,
      userName,
      userHeadIcon,
      caption,
      fetchSeoComment,
      roundingNum,
      handleCommentClick,
      copyUrl,
      handleLikeAction,
      clickHeaderOrName,
      clickPictureCard,
      cardType,
      cardCommonParams,
      handleNewOpenKwaiNotice,
      handleNewOpenKwaiNoticeClose,
      showNewOpenKwaiNotice,
      imageRef,
      pictureHeight,
      PictureIdPrefix,
    };
  },
});

